import { render } from "./Chart.vue?vue&type=template&id=51781f3c"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=51781f3c&lang=css"
script.render = render

export default script